import { LogLevel } from "@azure/msal-browser";
let appConfig = null;
export async function loadAppConfig() {
    if (appConfig)
        return appConfig;
    const response = await fetch("/appconfig.json");
    if (!response.ok) {
        throw new Error("Failed to load appconfig.json");
    }
    appConfig = await response.json();
    return appConfig;
}
export function getMsalConfig(config) {
    return {
        auth: {
            clientId: config.clientId,
            authority: `https://login.microsoftonline.com/${config.tenantId}`,
            redirectUri: config.redirectUri,
        },
        cache: {
            cacheLocation: "sessionStorage",
            storeAuthStateInCookie: false,
        },
        system: {
            loggerOptions: {
                loggerCallback: (_level, message, containsPii) => {
                    if (!containsPii) {
                        console.log(message);
                    }
                },
                logLevel: LogLevel.Warning,
            },
        },
    };
}
export const loginRequest = {
    scopes: ["openid", "profile", "User.Read"],
};
